import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { AuthenticationService } from "../services/auth.service";

@Injectable({ providedIn: "root" })
/**
 *
 */
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  /**
   *
   * @param route
   * @param state
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser: any = this.authenticationService.currentUser();

    if (currentUser) {
      let admin_route: any = ["/user", "/service-desk", "/import", "/export"];
      admin_route = admin_route.map((r) =>
        parent.location.pathname.startsWith(r)
      );
      if (admin_route.some((r) => r === true)) {
        if (currentUser.profile !== "a") {
          this.router.navigate(["/"]);
          return false;
        }
      }
      return true;
    }

    this.router.navigate(["/account/login"]);
    return false;
  }
}
